import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LogoutConfirmationModal = ({ isOpen, onClose, onConfirm, action, session }) => {
  if (!isOpen) return null;

  const getModalContent = () => {
    switch (action) {
      case 'single':
        return {
          title: 'Logout This Session?',
          description: `Are you sure you want to logout from ${session?.device_name || session?.device_type}? This action cannot be undone.`,
          icon: 'LogOut',
          iconColor: 'text-warning',
          iconBg: 'bg-warning/10',
          confirmText: 'Logout Session',
          confirmVariant: 'warning'
        };
      case 'all-other':
        return {
          title: 'Logout All Other Devices?',
          description: 'This will logout all active sessions except your current device. You will need to login again on those devices.',
          icon: 'Smartphone',
          iconColor: 'text-warning',
          iconBg: 'bg-warning/10',
          confirmText: 'Logout Other Devices',
          confirmVariant: 'warning'
        };
      case 'all':
        return {
          title: 'Logout All Sessions?',
          description: 'This is a security action that will logout ALL active sessions including your current device. You will be redirected to the login page.',
          icon: 'ShieldAlert',
          iconColor: 'text-error',
          iconBg: 'bg-error/10',
          confirmText: 'Logout All Sessions',
          confirmVariant: 'danger'
        };
      default:
        return {};
    }
  };

  const content = getModalContent();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="relative bg-card rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 border border-border">
        {/* Icon */}
        <div className={`w-12 h-12 rounded-full ${content?.iconBg} flex items-center justify-center mb-4`}>
          <Icon name={content?.icon} size={24} className={content?.iconColor} />
        </div>

        {/* Content */}
        <h3 className="text-xl font-bold text-foreground mb-2">{content?.title}</h3>
        <p className="text-muted-foreground mb-6">{content?.description}</p>

        {/* Session Details (for single logout) */}
        {action === 'single' && session && (
          <div className="bg-muted/50 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-3 mb-2">
              <Icon name="Monitor" size={16} className="text-muted-foreground" />
              <span className="text-sm font-medium text-foreground">
                {session?.device_name || session?.device_type}
              </span>
            </div>
            <div className="flex items-center gap-3 mb-2">
              <Icon name="MapPin" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{session?.location || 'Unknown location'}</span>
            </div>
            <div className="flex items-center gap-3">
              <Icon name="Globe" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground font-mono">{session?.ip_address}</span>
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex gap-3">
          <Button
            variant="outline"
            fullWidth
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant={content?.confirmVariant}
            fullWidth
            onClick={onConfirm}
            iconName="LogOut"
          >
            {content?.confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;